import React from 'react';
import Cropper from 'react-easy-crop';

function CropImage({
  aspect,
  crop,
  zoom,
  image,
  onZoom,
  onCrop,
  onSetCropArea,
  onCropComplete,
  ...rest
}) {
  return (
    <Cropper
      image={image}
      aspect={aspect}
      crop={crop}
      zoom={zoom}
      zoomSpeed={0.3}
      minZoom={0.1}
      maxZoom={10}
      onCropChange={onCrop}
      onZoomChange={onZoom}
      onCropComplete={onCropComplete}
      restrictPosition={false}
      onCropAreaChange={croppedArea => {
        onSetCropArea(croppedArea);
      }}
      {...rest}
    />
  );
}

export default CropImage;
